import styled from '@emotion/styled';
import { ob } from '../onboardingV2.tokens';

/** Fields wrapper (fieldset disabled while submitting). */
export const Fields = styled.fieldset`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0;
    padding: 0;
    border: 0;
    min-width: 0;
`;

export const Stack = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap || 12}px;
    margin-top: ${({ top }) => top || 0}px;
`;

export const AlertSlot = styled.div`
    margin-bottom: 20px;

    &:empty {
        display: none;
    }
`;

export const Suggestion = styled.button`
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    min-height: ${ob.tap};
    margin-top: -16px;
    padding: 0;
    border: 0;
    background: transparent;
    font-family: ${ob.font.body};
    font-size: 14px;
    color: ${ob.color.body};
    cursor: pointer;
    text-align: left;

    strong {
        margin-left: 4px;
        color: ${ob.color.brand};
        text-decoration: underline;
        text-underline-offset: 2px;
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
        border-radius: 8px;
    }
`;

export const Legal = styled.p`
    margin: 24px 0 0;
    font-size: 14px;
    line-height: 1.5;
    color: ${ob.color.body};

    a {
        color: ${ob.color.brand};
        font-weight: 600;
        text-decoration: underline;
        text-underline-offset: 2px;
    }
`;

export const InlineLink = styled.a`
    color: inherit;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
`;

export const FooterNote = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    text-align: center;
    color: ${ob.color.muted};
`;

export const Center = styled.div`
    display: flex;
    justify-content: center;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
`;

export const TipSlot = styled.div`
    margin-top: 24px;
`;
